function unique (list) {
  let result = []
  let count = {}
  let final = []
  for (let key in list) {
    if (result.indexOf(list[key]) === -1) {
      result.push(list[key])
      count[list[key]] = 1
    } else {
      count[list[key]]++
    }
  }
  for (let key in result) {
    let item = result[key]
    if (count[item] > 1) {
      final.push({'value': item, 'label': item + ' (' + count[item] + ')'})
    } else {
      final.push({'value': item, 'label': item})
    }
  }
  return final
}

function fillErrors (dest, source) {
  for (let key in dest) {
    dest[key] = []
  }

  for (let key in source) {
    if (key in dest) {
      dest[key] = source[key]
    }
  }
}

function fillNonFieldErrors (dest, source) {
  for (let key in dest) {
    if (key === 'non_field_errors') {
      dest[key] = []
    }
  }

  for (let key in source) {
    if (key in dest) {
      dest[key] = source[key]
    }
  }
}

function loadFromQueryParams ($route, filter, def = '', storagePrfx = '') {
  if (filter) {
    if (filter in $route.query) {
      return $route.query[filter]
    } else {
      if (storagePrfx.length) {
        return localStorage.getItem(storagePrfx + filter)
      } else {
        return def
      }
    }
  } else {
    return def
  }
}

function smartBackButton (routeName) {
  let path = localStorage.getItem('previous_page_path')
  let query = localStorage.getItem('previous_page_query')

  let routePath = this.$router.resolve({
    name: routeName
  }).href

  if (path === routePath && query) {
    this.$router.go(-1)
  } else {
    this.$router.push({ name: routeName })
  }
}

function isArray (value) {
  return value && typeof value === 'object' && value.constructor === Array
};

function uniqueSelect (list) {
  let result = []
  let final = []
  for (let key in list) {
    if (result.indexOf(list[key]['value']) === -1) {
      result.push(list[key]['value'])
    }
  }
  for (let key in result) {
    final.push({value: result[key], label: result[key]})
  }
  return final
}

function toMoney (val, currency = 'UAH') {
  val = parseFloat(val)

  if (val !== undefined) {
    return val.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,') + ' ' + currencySign(currency)
  } else {
    return '0.00' + ' ' + currencySign(currency)
  }
}

function currencySign (currency = 'UAH') {
  let sign = 'грн'

  if (currency === 'USD') {
    sign = '$'
  } else if (currency === 'GBP') {
    sign = '£'
  } else if (currency === 'EUR') {
    sign = '€'
  } else if (currency === 'UAH') {
    sign = 'грн'
  }

  return sign
}

function formatDate (val) {
  let date = new Date()

  if (typeof val === 'string') {
    date = new Date(val)
  } else {
    date = val
  }

  let options = {
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
    // second: '2-digit'
  }

  // let optionsDate = {
  //   year: 'numeric',
  //   month: 'short',
  //   day: 'numeric'
  //   // hour: '2-digit',
  //   // minute: '2-digit'
  //   // second: '2-digit'
  // }

  // return date.toLocaleTimeString('en-us', options)
  return date.toLocaleTimeString('ru', options)

  // return (date.getMonth() + 1) + '/' +
  //       date.getDate() + '/' +
  //       date.getFullYear() + ' ' +
  //       (date.getHours() < 10 ? '0' : '') + date.getHours() + ':' +
  //       (date.getMinutes() < 10 ? '0' : '') + date.getMinutes() + ':' +
  //       (date.getSeconds() < 10 ? '0' : '') + date.getSeconds()
}

function formatDateTime (val) {
  let date = new Date()

  if (typeof val === 'string') {
    date = new Date(val)
  } else {
    date = val
  }

  let options = {
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
    // second: '2-digit'
  }

  // let optionsDate = {
  //   year: 'numeric',
  //   month: 'short',
  //   day: 'numeric'
  //   // hour: '2-digit',
  //   // minute: '2-digit'
  //   // second: '2-digit'
  // }

  // return date.toLocaleTimeString('en-us', options)
  return date.toLocaleTimeString('ru', options)

  // return (date.getMonth() + 1) + '/' +
  //       date.getDate() + '/' +
  //       date.getFullYear() + ' ' +
  //       (date.getHours() < 10 ? '0' : '') + date.getHours() + ':' +
  //       (date.getMinutes() < 10 ? '0' : '') + date.getMinutes() + ':' +
  //       (date.getSeconds() < 10 ? '0' : '') + date.getSeconds()
}

export default {
  unique,
  uniqueSelect,
  toMoney,
  formatDate,
  formatDateTime,
  isArray,
  currencySign,
  fillErrors,
  fillNonFieldErrors,
  loadFromQueryParams,
  smartBackButton
}



// WEBPACK FOOTER //
// ./src/helpers.js